// @ts-check
import React from 'react';
import { drawerClasses } from '@liquidweb-dev/undercurrent/Drawer';
import MuiSwipeableDrawer from '@liquidweb-dev/undercurrent/MuiSwipeableDrawer';
import DrawerFooter from '@liquidweb-dev/undercurrent/DrawerFooter';
import { useSelector } from 'react-redux';
import appConfigSelectors from 'modules/appConfig/selectors';
import useLeftHandLayout from '../context';
import SmallNavAccount from './Account';
import LeftNavList from '../LeftNav/List';
import SmallNavCreateFooter from './CreateFooter';

export function SmallNavDrawer() {
	const { mobileOpen, setMobileOpen, topSize } = useLeftHandLayout();

	const { headsUpDisplay } = useSelector(appConfigSelectors.getAppConfig);

	return (
		<MuiSwipeableDrawer
			hideBackdrop
			open={mobileOpen}
			onOpen={() => setMobileOpen(true)}
			onClose={() => setMobileOpen(false)}
			component="nav"
			anchor="left"
			variant="temporary"
			sx={{
				pointerEvents: 'none',
				[`& .${drawerClasses.paper}`]: {
					pointerEvents: 'all',
					width: '100%',
					height: `calc(100dvh - ${topSize}px)`,
					marginTop: `${topSize}px`,
					padding: 0,
					backgroundColor: (theme) => theme.vars.palette.uc.bg.weak,

					// account for height of HeadsUpDisplay
					...(Boolean(headsUpDisplay) && { paddingBottom: '32px !important' }),
				},
			}}
		>
			<SmallNavAccount />
			<LeftNavList sx={{ flex: '0% 1 1' }} />
			<DrawerFooter sx={{ padding: 0 }}>
				<SmallNavCreateFooter />
			</DrawerFooter>
		</MuiSwipeableDrawer>
	);
}

export default SmallNavDrawer;
